import React from 'react';
import PropTypes from 'prop-types';

import { Text } from 'components/DataDisplay';
import { Modal } from 'components/Feedback';
import { Button } from 'components/Inputs';
import { Container, Item, Row } from 'components/Layout';

export const ModalDelete = props => {
  const { onClose, onDelete, name } = props;

  return (
    <Modal titleHead="Suppression" maxWidth="xs" {...props}>
      <Container>
        <Row>
          <Text>
            Êtes-vous sûr(e) de vouloir supprimer le board ?
            <Text bold style={{ justifySelf: 'center' }}>
              {name || ''}
            </Text>
          </Text>
        </Row>
        <Row>
          <Item xs={12} sm={6} padding="0px">
            <Button
              variant="outlined"
              size="medium"
              widthSize="medium"
              rounded
              onClick={onClose}
            >
              Annuler
            </Button>
          </Item>
          <Item xs={12} sm={6} padding="0px">
            <Button
              variant="outlined"
              size="medium"
              widthSize="medium"
              rounded
              onClick={onDelete}
            >
              Supprimer
            </Button>
          </Item>
        </Row>
      </Container>
    </Modal>
  );
};

ModalDelete.propTypes = {
  onDelete: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired
};

export default ModalDelete;
